// AUTO-GENERATED by scripts/extract-tokens.ts — do not edit by hand.

/** @reserved 추후 디자인 가이드 변경 대응용. 현재 사용하지 않음. */
export const BREAKPOINT_TABLET = 600;
export const BREAKPOINT_DESKTOP = 1024;
export const MAX_CONTENT_WIDTH = 1320;
